import React, { useEffect, useRef, useState } from "react";
import StatsLoad from "../../../assets/animationicons/stats-load.json";
import LottiePlayer from "lottie-react";
import ChatBotImg from "../../../assets/images/summ_analytics.png";
import { CloseIcon } from "../../../assets/icons/iconshere";
import { useSelector } from "react-redux";
import axios from "axios";

const SummarizeAnalytics = ({ moduleId, aiPayloadData, showPopup, setShowPopup, isChatbotVisible }) => {
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const [loadingData, setLoadingData] = useState(true);
  const [aiInsight, setAiInsight] = useState("");
  const API_URL = configData?.config?.API_URL;
  const body = document.body;
  const timerRef = useRef(null);
  const showChatBox = showPopup.aiAnalytics;

  const fetchAiAnalyticsOfCourse = async () => {
    const { sessions, lastSessionId } = aiPayloadData;
    if (sessions?.length > 0 && lastSessionId) {
      try {
        const payload = {
          moduleId,
          lastSessionId,
          userId: userData?.user?.uuid,
          sessionIdList: sessions.map((item) => item.uuid),
          userName: userData?.user?.name,
        };
        setLoadingData(true);
        const response = await axios.post(`${API_URL}/api/analytics/ai/data`, payload, {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        });
        if (response.data?.data?.inProcess) {
          timerRef.current = setTimeout(() => fetchAiAnalyticsOfCourse(), 5000);
        } else {
          // This is not by mistake, it is intentional. if removed html content might break
          setAiInsight(JSON.parse(JSON.stringify(response.data?.data?.data || {}))?.insights || "");
          setLoadingData(false);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    fetchAiAnalyticsOfCourse();
    return () => {
      clearTimeout(timerRef.current);
    };
  }, [moduleId, aiPayloadData?.sessions, aiPayloadData?.lastSessionId]);

  const openChatBox = () => {
    // setShowChatBox(!showChatBox);
    setShowPopup((prev) => ({ aiAnalytics: !prev.aiAnalytics, chatbot: false }));
    if (!showChatBox) {
      body.classList.add("filter-active");
    } else {
      body.classList.remove("filter-active");
    }
  };

  return (
    <>
      <div className="chat-bot analytics">
        <div className="chat-parent">
          <span className={`${!isChatbotVisible && "no-chatBot"} bot-here`} onClick={() => openChatBox()}>
            {/* dsads */}
            <img src={ChatBotImg} alt="chabot" />
            {!showChatBox && <p className="tooltip">Summarized AI Analytics</p>}
          </span>
        </div>
      </div>
      {showChatBox && (
        <div className="preview-parent">
          <div className="analyticsScreenParent" onClick={() => openChatBox()}>
            <div className="analyticsScreen" onClick={(e) => e.stopPropagation()}>
              {loadingData ? (
                <>
                  <div className="load-at-analytics">
                    <LottiePlayer animationData={StatsLoad} style={{ height: 150, marginBottom: 0, border: "none" }} />
                    <p>Summarizing analytics</p>
                  </div>
                </>
              ) : (
                <div className="summarizedParent" dangerouslySetInnerHTML={{ __html: aiInsight }}></div>
              )}
            </div>
            <span
              className="closePopup"
              onClick={(e) => {
                e.stopPropagation();
                openChatBox();
              }}
            >
              <CloseIcon />
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default SummarizeAnalytics;
